import { ActionTypes } from "../../constants/action-types";

const initialState = {
    countries: [],
    sector: [],
    statutoryIndustry: [],
    phases: [],
    organisations: [],
    competenciesScore: [],
    personalSkills: [],
    qualifications: [],
    educations: [],
    functions: [],
    category: [],
    jobTitles: [],
    grade: [],
    region: [],
    system: [],
    systemExpereine: [],
    systemExpereineScoring: []
};

export const adminReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case ActionTypes.SET_COUNTRIES:
            return {
                ...state,
                countries: payload
            };

        case ActionTypes.SET_SECTORS:
            return {
                ...state,
                sector: payload
            };

        case ActionTypes.ADD_SECTORS:
            return {
                ...state,
                sector: [
                    ...state.sector,
                    payload
                ]
            }

        case ActionTypes.UPDATE_SECTORS:
            return {
                ...state, // Returns the current state
                sector: state.sector.map(obj => obj.id === payload.id ? // Loop through the array to find the post you want to modify
                    payload : obj // Copy the post state and then modify it. Else return the same object.
                )
            }

        case ActionTypes.DELETE_SECTORS:
            return {
                ...state,
                sector: state.sector.filter((val) => val.id !== payload)
            }

        case ActionTypes.SET_STATUTORY_INDUSTRY:
            return {
                ...state,
                statutoryIndustry: payload
            };

        case ActionTypes.ADD_STATUTORY_INDUSTRY:
            return {
                ...state,
                statutoryIndustry: [
                    ...state.statutoryIndustry,
                    payload
                ]
            }

        case ActionTypes.UPDATE_STATUTORY_INDUSTRY:
            return {
                ...state, // Returns the current state
                statutoryIndustry: state.statutoryIndustry.map(obj => obj.id === payload.id ? // Loop through the array to find the post you want to modify
                    payload : obj // Copy the post state and then modify it. Else return the same object.
                )
            }

        case ActionTypes.DELETE_STATUTORY_INDUSTRY:
            return {
                ...state,
                statutoryIndustry: state.statutoryIndustry.filter((val) => val.id !== payload)
            }


        case ActionTypes.SET_PHASES:
            return {
                ...state,
                phases: payload
            };

        case ActionTypes.ADD_PHASES:
            return {
                ...state,
                phases: [
                    ...state.phases,
                    payload
                ]
            }

        case ActionTypes.UPDATE_PHASES:
            return {
                ...state, // Returns the current state
                phases: state.phases.map(obj => obj.id === payload.id ? // Loop through the array to find the post you want to modify
                    payload : obj // Copy the post state and then modify it. Else return the same object.
                )
            }

        case ActionTypes.DELETE_PHASES:
            return {
                ...state,
                phases: state.phases.filter((val) => val.id !== payload)
            }

        case ActionTypes.SET_ORGANISATIONS:
            return {
                ...state,
                organisations: payload
            };

        case ActionTypes.ADD_ORGANISATIONS:
            return {
                ...state,
                organisations: [
                    ...state.organisations,
                    payload
                ]
            }

        case ActionTypes.UPDATE_ORGANISATIONS:
            return {
                ...state, // Returns the current state
                organisations: state.organisations.map(obj => obj.id === payload.id ? // Loop through the array to find the post you want to modify
                    payload : obj // Copy the post state and then modify it. Else return the same object.
                )
            }

        case ActionTypes.DELETE_ORGANISATIONS:
            return {
                ...state,
                organisations: state.organisations.filter((val) => val.id !== payload)
            }

        case ActionTypes.SET_COMPETENCIES_SCORE:
            return {
                ...state,
                competenciesScore: payload
            };

        case ActionTypes.ADD_COMPETENCIES_SCORE:
            return {
                ...state,
                competenciesScore: [
                    ...state.competenciesScore,
                    payload
                ]
            }

        case ActionTypes.UPDATE_COMPETENCIES_SCORE:
            return {
                ...state, // Returns the current state
                competenciesScore: state.competenciesScore.map(obj => obj.id === payload.id ? // Loop through the array to find the post you want to modify
                    payload : obj // Copy the post state and then modify it. Else return the same object.
                )
            }

        case ActionTypes.DELETE_COMPETENCIES_SCORE:
            return {
                ...state,
                competenciesScore: state.competenciesScore.filter((val) => val.id !== payload)
            }

        case ActionTypes.SET_PERSONAL_SKILLS:
            return {
                ...state,
                personalSkills: payload
            };

        case ActionTypes.ADD_PERSONAL_SKILLS:
            return {
                ...state,
                personalSkills: [
                    ...state.personalSkills,
                    payload
                ]
            }

        case ActionTypes.UPDATE_PERSONAL_SKILLS:
            return {
                ...state, // Returns the current state
                personalSkills: state.personalSkills.map(obj => obj.id === payload.id ? // Loop through the array to find the post you want to modify
                    payload : obj // Copy the post state and then modify it. Else return the same object.
                )
            }

        case ActionTypes.DELETE_PERSONAL_SKILLS:
            return {
                ...state,
                personalSkills: state.personalSkills.filter((val) => val.id !== payload)
            }

        case ActionTypes.SET_QUALIFICATIONS:
            return {
                ...state,
                qualifications: payload
            };

        case ActionTypes.ADD_QUALIFICATIONS:
            return {
                ...state,
                qualifications: [
                    ...state.qualifications,
                    payload
                ]
            }

        case ActionTypes.UPDATE_QUALIFICATIONS:
            return {
                ...state, // Returns the current state
                qualifications: state.qualifications.map(obj => obj.id === payload.id ? // Loop through the array to find the post you want to modify
                    payload : obj // Copy the post state and then modify it. Else return the same object.
                )
            }

        case ActionTypes.DELETE_QUALIFICATIONS:
            return {
                ...state,
                qualifications: state.qualifications.filter((val) => val.id !== payload)
            }

        case ActionTypes.SET_EDUCATIONS:
            return {
                ...state,
                educations: payload
            };

        case ActionTypes.ADD_EDUCATIONS:
            return {
                ...state,
                educations: [
                    ...state.educations,
                    payload
                ]
            }

        case ActionTypes.UPDATE_EDUCATIONS:
            return {
                ...state, // Returns the current state
                educations: state.educations.map(obj => obj.id === payload.id ? // Loop through the array to find the post you want to modify
                    payload : obj // Copy the post state and then modify it. Else return the same object.
                )
            }

        case ActionTypes.DELETE_EDUCATIONS:
            return {
                ...state,
                educations: state.educations.filter((val) => val.id !== payload)
            }

        case ActionTypes.SET_FUNCTIONS:
            return {
                ...state,
                functions: payload
            };

        case ActionTypes.ADD_FUNCTIONS:
            return {
                ...state,
                functions: [
                    ...state.functions,
                    payload
                ]
            }

        case ActionTypes.UPDATE_FUNCTIONS:
            return {
                ...state, // Returns the current state
                functions: state.functions.map(obj => obj.id === payload.id ? // Loop through the array to find the post you want to modify
                    payload : obj // Copy the post state and then modify it. Else return the same object.
                )
            }

        case ActionTypes.DELETE_FUNCTIONS:
            return {
                ...state,
                functions: state.functions.filter((val) => val.id !== payload)
            }

        case ActionTypes.SET_CATEGORYS:
            return {
                ...state,
                category: payload
            };

        case ActionTypes.ADD_CATEGORYS:
            return {
                ...state,
                category: [
                    ...state.category,
                    payload
                ]
            }

        case ActionTypes.UPDATE_CATEGORYS:
            return {
                ...state, // Returns the current state
                category: state.category.map(obj => obj.id === payload.id ? // Loop through the array to find the post you want to modify
                    payload : obj // Copy the post state and then modify it. Else return the same object.
                )
            }

        case ActionTypes.DELETE_CATEGORYS:
            return {
                ...state,
                category: state.category.filter((val) => val.id !== payload)
            }

        case ActionTypes.SET_JOB_TITLES:
            return {
                ...state,
                jobTitles: payload
            };

        case ActionTypes.ADD_JOB_TITLES:
            return {
                ...state,
                jobTitles: [
                    ...state.jobTitles,
                    payload
                ]
            }

        case ActionTypes.UPDATE_JOB_TITLES:
            return {
                ...state, // Returns the current state
                jobTitles: state.jobTitles.map(obj => obj.id === payload.id ? // Loop through the array to find the post you want to modify
                    payload : obj // Copy the post state and then modify it. Else return the same object.
                )
            }

        case ActionTypes.DELETE_JOB_TITLES:
            return {
                ...state,
                jobTitles: state.jobTitles.filter((val) => val.id !== payload)
            }

        case ActionTypes.SET_GRADE:
            return {
                ...state,
                grade: payload
            };

        case ActionTypes.ADD_GRADE:
            return {
                ...state,
                grade: [
                    ...state.grade,
                    payload
                ]
            }

        case ActionTypes.UPDATE_GRADE:
            return {
                ...state, // Returns the current state
                grade: state.grade.map(obj => obj.id === payload.id ? // Loop through the array to find the post you want to modify
                    payload : obj // Copy the post state and then modify it. Else return the same object.
                )
            }

        case ActionTypes.DELETE_GRADE:
            return {
                ...state,
                grade: state.grade.filter((val) => val.id !== payload)
            }

        case ActionTypes.SET_REGION:
            return {
                ...state,
                region: payload
            };

        case ActionTypes.ADD_REGION:
            return {
                ...state,
                region: [
                    ...state.ADD_REGION,
                    payload
                ]
            }

        case ActionTypes.UPDATE_REGION:
            return {
                ...state, // Returns the current state
                region: state.region.map(obj => obj.id === payload.id ? // Loop through the array to find the post you want to modify
                    payload : obj // Copy the post state and then modify it. Else return the same object.
                )
            }

        case ActionTypes.DELETE_REGION:
            return {
                ...state,
                region: state.region.filter((val) => val.id !== payload)
            }


        case ActionTypes.SET_SYSTEMS:
            return {
                ...state,
                system: payload
            };

        case ActionTypes.ADD_SYSTEMS:
            return {
                ...state,
                system: [
                    ...state.system,
                    payload
                ]
            }

        case ActionTypes.UPDATE_SYSTEMS:
            return {
                ...state, // Returns the current state
                system: state.system.map(obj => obj.id === payload.id ? // Loop through the array to find the post you want to modify
                    payload : obj // Copy the post state and then modify it. Else return the same object.
                )
            }

        case ActionTypes.DELETE_SYSTEMS:
            return {
                ...state,
                system: state.system.filter((val) => val.id !== payload)
            }

        case ActionTypes.SET_SYSTEM_EXPEREINCE:
            return {
                ...state,
                systemExpereine: payload
            };

        case ActionTypes.ADD_SYSTEM_EXPEREINCE:
            return {
                ...state,
                systemExpereine: [
                    ...state.systemExpereine,
                    payload
                ]
            }

        case ActionTypes.UPDATE_SYSTEM_EXPEREINCE:
            return {
                ...state, // Returns the current state
                systemExpereine: state.systemExpereine.map(obj => obj.id === payload.id ? // Loop through the array to find the post you want to modify
                    payload : obj // Copy the post state and then modify it. Else return the same object.
                )
            }

        case ActionTypes.DELETE_SYSTEM_EXPEREINCE:
            return {
                ...state,
                systemExpereine: state.systemExpereine.filter((val) => val.id !== payload)
            }

        case ActionTypes.SET_SYSTEM_EXPEREINCE_SCORING:
            return {
                ...state,
                systemExpereineScoring: payload
            };

        case ActionTypes.ADD_SYSTEM_EXPEREINCE_SCORING:
            return {
                ...state,
                systemExpereineScoring: [
                    ...state.systemExpereineScoring,
                    payload
                ]
            }

        case ActionTypes.UPDATE_SYSTEM_EXPEREINCE_SCORING:
            return {
                ...state, // Returns the current state
                systemExpereineScoring: state.systemExpereineScoring.map(obj => obj.id === payload.id ? // Loop through the array to find the post you want to modify
                    payload : obj // Copy the post state and then modify it. Else return the same object.
                )
            }

        case ActionTypes.DELETE_SYSTEM_EXPEREINCE_SCORING:
            return {
                ...state,
                systemExpereineScoring: state.systemExpereineScoring.filter((val) => val.id !== payload)
            }

        case ActionTypes.RESET_STORE:
            return {
                ...(state = initialState)
            };

        default:
            return state;
    }
};
